export { VacDocPoll } from './VacDocPoll';
